import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

type PlaceholderBarProps = {
  className?: string;
};

export const PlaceholderBar: FC<PlaceholderBarProps> = ({ className }) => (
  <div className={twMerge('rounded bg-gray-200', className)} />
);
